
// const rules = `<p style="text-align: justify;">Timer starts as soon as you click on '<strong>Start' button</strong>. You have to&nbsp;<strong>complete the test within the specified time</strong>&nbsp;and no extra time is allowed.&nbsp;</p>
// <p style="text-align: justify;">You can&nbsp;<strong>attempt the test one more time after finishing your first attempt</strong>. Once you click on the 'Finish' button, a pop-up box will appear. If you click on 'Submit' button on the box, no changes can be done after it.&nbsp;</p>
// <p style="text-align: justify;">Once you select an option,&nbsp;<strong>&lsquo;Clear&rsquo; button appears. Use this button to erase a chosen option.&nbsp;</strong></p>
// <p style="text-align: justify;">This test consists of&nbsp;<strong>100 questions only in English.</strong>&nbsp;Each item comprises four responses. You have to select only one response. In case you feel that there is more than one correct response, mark the response which you consider the best.&nbsp;</p>
// <p style="text-align: justify;">There is&nbsp;<strong>negative marking for incorrect answers.</strong>&nbsp;The penalty for incorrect answer is one-third of the marks allotted to that question.&nbsp;</p>
// <p style="text-align: justify;">Mark only one option in the answer sheet for each question. If you mark more than one answer, then the question will be deemed incorrect even if one of the answer options you marked happens to be the correct answer.&nbsp;</p>
// <p style="text-align: justify;">If a question is left unanswered, i.e., no option is marked, then no marks will be deducted for that question.</p>`




import React, { useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import CivilContent from '../../AllPageContent/AllPageContent'

const Instructions = () => {
    const location = useLocation();
    const [accepted, setAccepted] = useState(false);

    const rules = `<p style="text-align: justify;">Timer starts as soon as you click on '<strong>Start' button</strong>. You have to&nbsp;<strong>complete the test within the specified time</strong>&nbsp;and no extra time is allowed.&nbsp;</p>
<p style="text-align: justify;">You can&nbsp;<strong>attempt the test one more time after finishing your first attempt</strong>. Once you click on the 'Finish' button, a pop-up box will appear. If you click on 'Submit' button on the box, no changes can be done after it.&nbsp;</p>
<p style="text-align: justify;">Once you select an option,&nbsp;<strong>&lsquo;Clear&rsquo; button appears. Use this button to erase a chosen option.&nbsp;</strong></p>
<p style="text-align: justify;">This test consists of&nbsp;<strong>100 questions only in English.</strong>&nbsp;Each item comprises four responses. You have to select only one response. In case you feel that there is more than one correct response, mark the response which you consider the best.&nbsp;</p>
<p style="text-align: justify;">There is&nbsp;<strong>negative marking for incorrect answers.</strong>&nbsp;The penalty for incorrect answer is one-third of the marks allotted to that question.&nbsp;</p>
<p style="text-align: justify;">Mark only one option in the answer sheet for each question. If you mark more than one answer, then the question will be deemed incorrect even if one of the answer options you marked happens to be the correct answer.&nbsp;</p>
<p style="text-align: justify;">If a question is left unanswered, i.e., no option is marked, then no marks will be deducted for that question.</p>`;

    return (
        <div className="p-sm-4 bg-light">
            <h2 className="text-center text-danger fs-4 fw-semibold mb-3">Read all the instructions carefully</h2>

            <div className="p-3 mb-4 rounded bg-warning-subtle shadow-sm border-start border-4 border-warning">
                <CivilContent paragraphs={rules} />
            </div>

            {/* Checkbox for Terms and Conditions */}
            <div className="form-check text-center mb-3 d-flex justify-content-center align-items-center">
                <input
                    type="checkbox"
                    id="acceptTerms"
                    className="form-check-input"
                    checked={accepted}
                    onChange={(e) => setAccepted(e.target.checked)}
                    style={{
                        transform: 'scale(1.5)',
                        cursor: 'pointer',
                        marginRight: '8px',
                        border: '1px solid',
                        borderColor: accepted ? 'green' : 'red',
                        borderRadius: '4px', // optional for rounded corners
                    }}
                />


                <label className="form-check-label ms-2 mt-1" htmlFor="acceptTerms">
                    I have read and agree to the Terms & Conditions
                </label>
            </div>

            {/* Start Button */}
            <div className="text-center">
                <Link
                    to={'/cuet/online-exam/live-test'}
                    state={{ testDetails: location?.state?.testDetails }}
                    className="btn btn-success px-4 py-2 fw-semibold shadow-sm"
                    style={{
                        pointerEvents: accepted ? 'auto' : 'none',
                        cursor: accepted ? 'pointer' : 'not-allowed',
                        opacity: accepted ? 1 : 0.6
                    }}
                >
                    Start Test
                </Link>
            </div>
        </div>
    );
};

export default Instructions;
